import React, { useState, useEffect } from "react";
import axios from "axios";
import Breadcrumb from "../components/Breadcrumb";

function About() {
  const [content, setContent] = useState({ headerImage: "", text: "" });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const response = await axios.get("/api/information/public/about");
        setContent(response.data);
      } catch (error) {
        console.error("Error fetching about content:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchContent();
  }, []);

  if (loading) {
    return (
      <div className="bg-white min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-opera-red mx-auto"></div>
          <p className="mt-4 text-black">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white">
      {/* Hero Section */}
      <div className="relative mt-[80px] sm:mt-[90px] md:mt-[125px] overflow-hidden">
        <img
          src={content.headerImage || "/images/welcome.jpeg"}
          alt="About OperaToday.org"
          className="w-full h-full object-scale-down xl:object-bottom"
          onError={(e) => {
            e.target.src = "/images/default-pic.jpg";
          }}
        />
      </div>
      {/* Breadcrumb */}
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Welcome", href: "/welcome" },
        ]}
      />

      {/* Main Content */}
      <main className="max-w-[1280px] mx-auto px-4 py-8">
        <h1 className="text-4xl md:text-3xl text-left mb-4">
          Welcome to OperaToday.org
        </h1>
        <p className="text-black text-lg font-normal mb-8 text-left md:text-left">
          Your Gateway to Unforgettable Opera Experiences
        </p>

        <div className="prose max-w-none">
          <div className="text-gray-700 text-lg leading-relaxed whitespace-pre-wrap" dangerouslySetInnerHTML={{
            __html: content.text ||
              "Welcome to OperaToday.org, your premier destination for discovering the world's most magnificent opera houses and performances. Our passion is connecting opera enthusiasts with extraordinary cultural experiences across the globe.\n\nWhether you're a seasoned opera lover or just beginning your journey into this magnificent art form, we provide carefully curated travel experiences that combine the grandeur of opera with the excitement of discovering new destinations.\n\nJoin us as we explore the world's most prestigious opera houses, from La Scala in Milan to the Vienna State Opera, and everything in between."
          }} />
          {/* <div className="text-gray-700 text-lg leading-relaxed whitespace-pre-wrap">
            {content.text ||
              "Welcome to OperaToday.org, your premier destination for discovering the world's most magnificent opera houses and performances. Our passion is connecting opera enthusiasts with extraordinary cultural experiences across the globe.\n\nWhether you're a seasoned opera lover or just beginning your journey into this magnificent art form, we provide carefully curated travel experiences that combine the grandeur of opera with the excitement of discovering new destinations.\n\nJoin us as we explore the world's most prestigious opera houses, from La Scala in Milan to the Vienna State Opera, and everything in between."}
          </div> */}
        </div>
      </main>
    </div>
  );
}

export default About;
